import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import 'basscss/css/basscss.min.css';
import './css/mds-brand.scss';
import './css/general.scss';
import './css/page.scss';
import './css/colors.scss';
import './css/codemirror-overrides.scss';
import 'forum-design-system/dist/forum-design-system.css';
import './css/mobile.scss';

ReactDOM.render(<App />, document.getElementById('root'));
